<template>
    <!-- contents -->
    <div>
        <!-- detail_Code Manage -->
        <div class="grid_wrap mt25">
            <div class="sub_tit">Basic Information</div>
        </div>
        <table class="create_table">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>{{$t('FIELD.CODEMNG.CODE.ID')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <span class="clearable">
                            <input ref="categoryId" type="text" class="text_input w100" placeholder="Category Id" v-model="categoryId" 
                                  :disabled="viewMode" v-clearable maxlength="30" />
                            <i class="clearable_clear">X</i>
                        </span>
                    </td>
                    <th>{{$t('FIELD.CODEMNG.CODE.NAME')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <span class="clearable">
                            <input ref="categoryName" type="text" class="text_input w100" placeholder="Category Name" v-model="categoryName" 
                                   v-clearable maxlength="67" />
                            <i class="clearable_clear">X</i>
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.CODEMNG.CODE.TYPE')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <select class="slt_white w100" v-model="categoryType">
                            <option value selected>{{$t('MESSAGE.CATEGORY.NOSELECTED')}}</option>
                            <option value="D">{{$t('FIELD.CODEMNG.DYNAMIC')}}</option>
                            <option value="S">{{$t('FIELD.CODEMNG.STATIC')}}</option>
                        </select>
                    </td>
                    <th>{{$t('FIELD.CODEMNG.QUERY.ID')}}<em v-if="categoryType == 'D'" class="txt_mandatory">*</em></th>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" placeholder="Query Id" v-model="queryId" :disabled="categoryType != 'D'" v-clearable />
                            <i class="clearable_clear">X</i>
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.CODEMNG.CASH.STATUS')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <select class="slt_white w100" v-model="cacheStatus">
                            <option value selected>{{$t('FIELD.GLOBAL.OPTION.DETAIL.NAME')}}</option>
                            <option value="N">{{$t('FIELD.GLOBAL.NO')}}</option>
                            <option value="Y">{{$t('FIELD.GLOBAL.YES')}}</option>
                        </select>
                    </td>
                    <th>{{$t('FIELD.GLOBAL.STATUS')}}<em class="txt_mandatory">*</em></th>
                    <td>
                        <select class="slt_white w100" v-model="status">
                            <option value selected>{{$t('FIELD.GLOBAL.OPTION.DETAIL.NAME')}}</option>
                            <option value="A">{{$t('FIELD.GLOBAL.ACTIVE')}}</option>
                            <option value="S">{{$t('FIELD.GLOBAL.SLEEP')}}</option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>{{$t('FIELD.CODEMNG.UPPER.CODE')}}</th>
                    <td colspan="3">
                        <fieldset class="ui_fieldset">
                            <label class="date-wrap input-58">
                                <input type="text" class="date_input w100p" placeholder="Upper Code" v-model="upperCode" readonly maxlength="20" />
                                <a href="JavaScript:" @click="clickUpperCode()" class="in_btn">
                                    <i class="ico_input_serach"></i>
                                    <span class="sr_only">X</span>
                                </a>
                            </label>
                        </fieldset>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- go list button -->
        <div class="btn_wrap topLine">
            <a v-if="!viewMode || categoryType =='D'" href="JavaScript:"
               @click="goList()" class="btn_white size_full" title>{{$t('BUTTON.GLOBAL.LIST')}}</a>
            <div class="btn_right" v-if="this.sysAdmYn == 'Y'">
                <a href="JavaScript:" class="btn_white" @click="cateDelete()">{{$t('BUTTON.GLOBAL.DELETE')}}</a>
                <a href="JavaScript:" class="btn_blue" @click="cateSave()">{{$t('BUTTON.GLOBAL.SAVE')}}</a>
            </div>
        </div>
        <!-- //detail_Code Manage -->
        <!-- Code Detail List : 수정모드 && Static일 떄만 보임. -->
        <div v-if="viewMode && categoryType =='S'">
            <div class="grid_wrap mt25">
                <div class="sub_tit">{{$t('SUBTITLE.CODEMNG.CODE.DETAIL.LIST')}}</div>
            </div>
            <!-- Code Detail List -->
            <table class="scroll_table">
                <colgroup>
                    <col width="5%" />
                    <col width="15%" />
                    <col width="25%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="15%" />
                </colgroup>
                <thead>
                    <th>
                        <label class="checkbox-wrap">
                            <input type="checkbox" v-model="selectAll" @change="checkAll()" />
                            <i class="check-icon"></i>
                        </label>
                    </th>
                    <th>{{$t('FIELD.CODEMNG.CODE')}}</th>
                    <th>{{$t('FIELD.CODEMNG.CODE.NAME')}}</th>
                    <th>{{$t('FIELD.CODEMNG.UPPER.CODE')}}</th>
                    <th>{{$t('FIELD.GLOBAL.STATUS')}}</th>
                    <th>{{$t('FIELD.GLOBAL.ORDER')}}</th>
                    <th>{{$t('FIELD.GLOBAL.MODIFY')}}</th>
                </thead>
                <tbody>
                    <tr v-for="item in detlCodes" :key="item.code">
                        <td class="tC">
                            <label class="checkbox-wrap">
                                <input type="checkbox" v-model="item.selected" @change="selectRowChk(item)" />
                                <i class="check-icon"></i>
                            </label>
                        </td>
                        <td class="tC" @click="clickDetCodeRow(item)">{{item.code}}</td>
                        <td class="tL" @click="clickDetCodeRow(item)">{{item.codeDesc}}</td>
                        <td class="tC" @click="clickDetCodeRow(item)">{{item.upperCodeId}}</td>
                        <td class="tC" @click="clickDetCodeRow(item)">{{item.statusCode}}</td>
                        <td class="tC" @click="clickDetCodeRow(item)">{{item.sortOrder}}</td>
                        <td class="tC">
                            <a
                                href="JavaScript:"
                                class="btn_sm_white"
                                @click="codeModify(item)"
                            >{{$t('BUTTON.GLOBAL.MODIFY')}}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //Code Detail List -->
            <div class="btn_wrap">
                <div class="btn_right pt-10" v-if="this.sysAdmYn == 'Y'">
                    <a href="JavaScript:" class="btn_white" @click="codeDel()" >{{$t('BUTTON.GLOBAL.DELETE')}}</a>
                    <a href="JavaScript:" class="btn_white" @click="codeAdd()" >{{$t('BUTTON.GLOBAL.ADD')}}</a>
                </div>
            </div>
            <div class="grid_wrap mt25">
                <!-- LabelSetting tit -->
                <div class="sub_tit">{{$t('FIELD.ADMIN.LABEL.SETTING')}}</div>
                <!-- //LabelSetting tit -->
            </div>
            <!-- LabelSettinge list-->
            <table class="scroll_table">
                <colgroup>
                    <col width="15%" />
                    <col width="10%" />
                    <col width="*" />
                </colgroup>
                <thead>
                    <th width="15%">{{$t('FIELD.GLOBAL.LANGUAGE')}}</th>
                    <th width="10%">{{$t('FIELD.GLOBAL.ORDER')}}</th>
                    <th width="*">{{$t('FIELD.CODEMNG.CODE.NAME')}}</th>
                </thead>
                <tbody>
                    <tr v-for="locale in localeList" :key="locale.locale" @change="changeLocale(locale)">
                        <td class="tC w13_5">{{locale.localeDesc}}</td>
                        <td class="tC w13_5">{{locale.sortOrder}}</td>
                        <td>
                            <span class="clearable">
                                <input type="text" name="localeCd" class="text_input" v-model="locale.codeName" maxlength="33" />
                                <i class="clearable_clear">X</i>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btn_wrap" v-if="localeList.length > 0">
                <div class="btn_right pt-10">
                    <a href="JavaScript:" class="btn_white" @click="localeCopy()" >{{$t('BUTTON.GLOBAL.COPY')}}</a>
                    <a href="JavaScript:" class="btn_blue" @click="localeSave()" >{{$t('BUTTON.GLOBAL.SAVE')}}</a>
                </div>
            </div>
        </div>
        <!-- //Label Setting list -->
        <!-- go list button -->
        <div v-if="viewMode && categoryType =='S'" class="btn_wrap_full topLine mt25">
            <a href="JavaScript:" @click="goList()" class="btn_white size_full" title >{{$t('BUTTON.GLOBAL.LIST')}}</a>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import _ from 'lodash';
import $ from 'jquery';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import CodeDetlPopup from './CodeDetlPopup';
import UpperCodePopup from './UpperCodePopup';

export default {
    name: 'CodeAdminDetail',
    props: {
        params: {},
        pCategoryId: '',
    },
    data() {
        return {
            isLoading: true,
            viewMode: false, // 'false=create, true=modify'
            categoryId: '',
            categoryName: '',
            categoryType: '',
            queryId: '',
            cacheStatus: '',
            status: 'A',
            upperCode: '',
            localeCd: '',
            currDetCode: '',
            selectAll: '',
            detlCodes: [],
            chkCodes: [],
            localeList: [],
            updateLocales: [],
            deleteItems: [],
            sysAdmYn:'',
        };
    },
    computed: {},
    watch: {},
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    methods: {
        initLoad() {
            if (this.pCategoryId) {
                // 수정모드
                this.dataLoad();
            } else {
                // 신규모드
                // 초기화
                this.detlCodes = [];
                this.localeList = [];
            }
        },
        dataLoad() {
            const data = { codeCategoryId: this.pCategoryId };
            return axios
                .get(`${SDLUtil.API_URL}/basis/admin/system/code/codeAdminDetail.skp`, { params: data })
                .then(resp => {
                    let cate = resp.data.category;
                    this.viewMode = this.pCategoryId ? true : false;
                    this.categoryType = cate.codeTypeCode || '';
                    this.categoryId = cate.codeCategoryId;
                    this.categoryName = cate.codeCategoryName;
                    this.queryId = cate.codeQueryDescripton;
                    this.cacheStatus = cate.cacheYn || '';
                    this.status = cate.statusCode || '';
                    this.upperCode = cate.upperCodeId;
                    this.detlCodes = cate.codes;
                })
                .catch(err => {
                    console.error(err);//console.error(error);//cb 22.8 error undefined
                });
        },
        saveParams(exclude = []) {
            let params = {
                updateMode: this.viewMode,
                codeCategoryId: this.categoryId,
                codeTypeCode: this.categoryType,
                codeCategoryName: this.categoryName,
                codeQueryDescripton: this.queryId,
                cacheYn: this.cashStatus,
                statusCode: this.status,
                upperCodeId: this.upperCode,
                riskPointName: '',
            };
            return params;
        },
        // aftMode: 1=goList(delete), 2=refresh(save)
        saveExec(url, formData, msg, aftMode) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(url, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(resp => {
                    SDLUtil.showLoadingBar(false);
                    if (resp.data.result > 0) {
                        Vue.toasted.show(
                            SDLUtil.getMsgProp(msg), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                        if (aftMode == 0) { // Save
                            this.viewMode = true;
                        } else if (aftMode == 1) { // Delete
                            EventBus.$emit('goCodeList', 1);
                        } else if (aftMode == 2) {
                            this.refresh(null);
                        }
                    } else {
                        SDLUtil.alert('Error occured ' + resp.status);
                    }
                })
                .catch(err => {
                    SDLUtil.alert('Error occured : ' + err);
                    this.searchStatus = 'error';
                    this.gridData = [];
                    SDLUtil.showLoadingBar(false);
                });
        },
        categoryValidateion() {
            let bRes = true;
            let valids = [this.categoryId, this.categoryName, this.categoryType, this.cacheStatus, this.status];
            let titles = ['Code ID', 'Code Name', 'Code Type', 'Cache Status', 'Status'];
            if (this.categoryType == 'D') {
                valids.push(this.queryId);
                titles.push('Query ID');
            }
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    bRes = false;
                    SDLUtil.alert('Empty value of [' + titles[idx] + ']');
                    return;
                }
            });
            return bRes;
        },
        // Main Save
        cateSave() {
            const fData = this.saveParams();
            if (!this.categoryValidateion()) {
                return;
            }
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/code/categorySave.skp`;
                    this.saveExec(url, fData, 'MESSAGE.SUCCESS.SAVED', 0);
                },
            });
        },
        // Main Delete
        cateDelete() {
            const fData = { codeCategoryId: this.categoryId };
            SDLUtil.confirm({
                msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                title: 'BUTTON.GLOBAL.DELETE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/code/categoryDelete.skp`;
                    this.saveExec(url, fData, 'MESSAGE.SUCCESS.DELETED', 1);
                },
            });
        },
        addDetlCode(rowData) {
            SDLUtil.showLoadingBar(true);
            SDLUtil.show(
                CodeDetlPopup,
                {
                    title: 'Detail Code Information',
                    pCategoryId: this.categoryId,
                    detlCodes: rowData,
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
            SDLUtil.showLoadingBar(false);
        },
        // UpperCode Popup
        clickUpperCode() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.show(
                UpperCodePopup, {
                    title: 'Upper Code Search',
                    pCategoryId: this.categoryId,
                    rtnFunc: arg1 => {
                        this.upperCode = arg1;
                    }
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
            SDLUtil.showLoadingBar(false);
        },
        clickDetCodeRow(row) {
            // DetailCode Row 클릭 시.. Locale 가져오기
            SDLUtil.showLoadingBar(true);
            this.currDetCode = row.code;
            let data = { codeCategoryId: this.categoryId, code: row.code };
            return axios
                .get(`${SDLUtil.API_URL}/basis/admin/system/code/codeAdminLocale.skp`, { params: data })
                .then(resp => {
                    this.localeList = resp.data.localeRows;
                    this.list2Str(this.localeList);
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    console.error(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        codeAdd() {
            // 신규 추가시..
            this.addDetlCode();
        },
        codeDel() {
            // 체크된 항목 삭제
            this.deleteItems = [];
            this.detlCodes.forEach(elm => {
                let chk = elm.selected;
                if (chk) this.deleteItems.push(elm.code);
            });

            if (this.deleteItems.length < 1) {
                SDLUtil.alert('MESSAGE.GROBAL.NOSELECT');
                return;
            }

            if (this.deleteItems.length == 1) this.deleteItems.push('0000');
            let fData = {
                codeCategoryId: this.categoryId,
                delCodes: this.deleteItems,
            };
            SDLUtil.confirm({
                msg: 'MESSAGE.DATA.REMOVE.CONFIRM',
                title: 'BUTTON.GLOBAL.DELETE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/code/adminCodeDelete.skp`;
                    this.saveExec(url, fData, 'Deleted successfully.', 2);
                },
            });
        },
        codeModify(row) {
            // 신규 추가시..
            this.addDetlCode(row);
        },
        changeLocale(loc) {
            let str1 = loc.locale;
            let str2 = loc.codeName;
            let newList = [];
            this.updateLocales.forEach(elm => {
                let spl = elm.split('$');
                let code = spl[0];
                if (code == str1) {
                    elm = str1 + '$' + str2;
                }
                newList.push(elm);
            });
            this.updateLocales = newList;
        },
        // Locale(Label) Save
        localeSave() {
            if (this.updateLocales.length == 0) {
                SDLUtil.alert('MESSAGE.GROBAL.NOSELECT');
                return;
            }
            const fData = {
                codeCategoryId: this.pCategoryId,
                code: this.currDetCode,
                locales: this.updateLocales,
            };
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/system/code/codeLocaleSave.skp`;
                    this.saveExec(url, fData, 'MESSAGE.SUCCESS.SAVED', 0);
                },
            });
        },
        localeCopy() {
            // Copy
            let first = this.localeList[0].codeName;
            if (first.trim() == 0) {
                SDLUtil.alert('MESSAGE.CODE.LOCALE.EMPTY');
                return;
            }
            let nList = [];
            this.localeList.forEach(elm => {
                elm.codeName = first;
                nList.push(elm);
            });
            this.localeList = nList;
            this.updateLocales = [];
            this.list2Str(nList);
        },
        refresh(data) {
            // 데이터 다시 불러오기
            if (this.categoryId) {
                this.pCategoryId = this.categoryId;
                this.dataLoad();
            }
        },
        list2Str(orgs) {
            this.updateLocales = [];
            orgs.forEach(elm => {
                let str1 = elm.locale;
                let str2 = elm.codeName;
                if (str2 == undefined || str2 == 'undefined') str2 = '';
                str2 = str2.replace(/$/g, '');
                this.updateLocales.push(str1 + '$' + str2);
            });
        },
        selectRowChk(item) {
            // 개별 checkbix click
            if (!item.selected) {
                if (this.selectAll) {
                    this.selectAll = false;
                }
            }
        },
        checkAll() {
            // 전체 checkbox click
            this.detlCodes.forEach(item => {
                item.selected = this.selectAll;
            });
        },
        goList() {
            EventBus.$emit('goCodeList', 1);
        },
    }, // methods
    created() {
        EventBus.$on('refresh', this.refresh);
    },
    mounted() {
        this.initLoad();
        if (!this.viewMode) this.$refs.categoryId.focus();
        //system admin 9900
        this.sysAdmYn = SDLUtil.isRoleExist(`${constants.SYSTEM_ADMIN}`) ? 'Y' : 'N' ;
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('refresh');
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/code/CodeAdminView.vue